import { VariantTypes } from "./types";

export const variantMap: Record<VariantTypes, number> = {
  title: 26,
  body: 14,
  caption: 12,
  headingExtraLarge: 112,
  heading: 22,
  heading1: 20,
  heading2: 18,
  heading3: 16,
  heading4: 15,
  heading5: 12,
};
